// src/components/sections/Count.js
import React from 'react';
import './Boost.css';
import TranslateText from '../../translation/TranslateText';

function Count() {
  return (
    <div className="boost-container">
      <h1 className="large-text4"><TranslateText text="WHY DOES GREAT CREDIT COUNT?" /></h1>
      <br />
      <div className='separator'></div>
      <br />

      <span className="large-text">
        <TranslateText text="When you have a low/subprime credit score (anything under 619), it feels like the whole financial world is against you and" />
      </span>
      <span className="large-text">
        <TranslateText text="life becomes more difficult and expensive. Millions of Americans" />
      </span>
      <span className="large-text">
        <TranslateText text="need to build up and sweep their credit in order to qualify for a home loan," />
      </span>
      <span className="large-text">
        <TranslateText text="lease an apartment, obtain a car loan, to get a credit card," />
      </span>
      <span className="large-text">
        <TranslateText text=" get a cell phone, and even applying for certain jobs." />
      </span>
      <span className="large-text">
        <TranslateText text="Your credit score even impacts the rates you pay for auto and homeowners insurance." />
      </span>


      <br />

      <span className="large-text boldPurple">
        <TranslateText text="By restoring and building your credit with a credit sweep and tradelines," />
      </span>
      <span className="large-text boldPurple">
        <TranslateText text="you can save thousands of dollars in lower interest on payments and much more." />
      </span>
      <span className="large-text boldPurple">
        <TranslateText text="We can help you to remove inaccurate information from your credit report" />
      </span>
      <span className="large-text boldPurple">
        <TranslateText text=" as well as enhance your credit with tradelines molded to your outcome." />
      </span>
      <br />
      
      <span className="large-text">
        <TranslateText text="Credit bureaus keep information on your record up to 10 years, " />
      </span>
      <span className="large-text">
        <TranslateText text="so problematic credit history can follow you around for a LONG time." />
      </span>
      <span className="large-text">
        <TranslateText text="You came to the right place to" /> <span className="boldPurple"><TranslateText text="skyrocket" /></span> <TranslateText text="your consumer buying power!" />
      </span>
      <br />
      <span className="large-text">
        <span className="boldPurple"><TranslateText text="Our clients on average will get 50 to 90% + of their issues permanently deleted in 45 to 60 days;" /></span> 
        
      </span>
      <span className="large-text">
      <TranslateText text="some reports may take more or less time depending" />
      </span>
      <span className="large-text">
        <TranslateText text="upon several factors like how many items are on the report, how old they are and " />
      </span>
      <span className="large-text">
        <TranslateText text="if you have gone through credit repair recently. Every credit report is" />
      </span>
      <span className="large-text">
        <TranslateText text="different so we work each one case by case to optimize for the best possible results." />
      </span>
      <br />
      <br />
      <span className="miniTitle"><TranslateText text="Elite Credit Repair Service" /></span>
      <span className="miniTitle"><TranslateText text="45-90 Days Guaranteed" /></span>
      <span className="miniTitle">$750</span>
      <br />
      <div className='separator'></div>
      <br />
    </div>
  );
}

export default Count;
